import { jsx } from 'react/jsx-runtime';
import { ReactComponent as SvgCrossSmall } from './svg/cross-small.svg.js';

/**
 * @deprecated - use Cross.
 *
 * @param {boolean} legacyBoundingBox - (optional) This prop has no effect on legacy icons with the Mid or Small name suffix.
 * @param {number} size - (optional) This prop has no effect on legacy icons with the Mid or Small name suffix.
 * @param {string} title - (optional) will be applied as `aria-label` unless an `aria-label` is explicitly set.
 */
const CrossSmall = (props) => {
    const { title, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    size: _size, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    legacyBoundingBox: _legacyBoundingBox, 'aria-label': ariaLabel, 'aria-label': ariaHidden, ...rest } = props;
    return (jsx(SvgCrossSmall, { viewBox: "-6 -6 36 36", "aria-hidden": !!ariaHidden || title || ariaLabel ? undefined : 'true', "aria-label": ariaLabel || title, role: "img", ...rest, width: 24, height: 24, "data-pp-icon": "CrossSmall" }));
};

export { CrossSmall as default };
//# sourceMappingURL=CrossSmall.js.map
